<template>
  <div class="m-0 h-screen w-screen p-0">
    <div class="z-20 mx-auto flex min-h-full flex-1 flex-col justify-center px-6 py-12 text-gray-300 lg:px-8">
      <AppSignLogo />
      <div class="flex w-full flex-row items-center justify-center text-center text-xl text-gray-300">
        <span>{{ $t('sign.out.signingOut') }} <AppDotAnimation clazz="w-4" /></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
onBeforeMount(() => {
  useMenu().reset()
  useBreadcrumb().reset()
})

// TODO fix errors while switching from high5 > sign-out using the sign layout
definePageMeta({
  layout: 'sign'
})

const { userStore, spaceStore } = await useStore('userStore', 'spaceStore')
const route = useRoute()

useTimeoutFn(async () => {
  userStore.$reset()
  spaceStore.$reset()

  if (route.query.redirect && route.query.redirect.toString().startsWith('/')) {
    await navigateTo(route.query.redirect.toString())
  } else {
    await navigateTo(useRouting().signIn.root())
  }
}, 1000)
</script>
